module.exports = __webpack_public_path__ + "img/sxk.88c2da34.jpg";